import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  BarChart3, PackagePlus, Users, Receipt, Server, LifeBuoy, LogOut, ShieldAlert, Ticket, Activity, Gauge,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const nav = [
  { to: "/admin", label: "Dashboard", icon: BarChart3, end: true, tid: "admin-nav-dashboard" },
  { to: "/admin/analytics", label: "Analytics", icon: Activity, tid: "admin-nav-analytics" },
  { to: "/admin/plans", label: "Planos", icon: PackagePlus, tid: "admin-nav-plans" },
  { to: "/admin/coupons", label: "Cupons", icon: Ticket, tid: "admin-nav-coupons" },
  { to: "/admin/clients", label: "Clientes", icon: Users, tid: "admin-nav-clients" },
  { to: "/admin/resellers", label: "Revendedores", icon: Users, tid: "admin-nav-resellers" },
  { to: "/admin/invoices", label: "Faturas", icon: Receipt, tid: "admin-nav-invoices" },
  { to: "/admin/vps", label: "VPS", icon: Server, tid: "admin-nav-vps" },
  { to: "/admin/monitoring", label: "Monitor", icon: Gauge, tid: "admin-nav-monitoring" },
  { to: "/admin/tickets", label: "Tickets", icon: LifeBuoy, tid: "admin-nav-tickets" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-[#09090B] text-zinc-100">
      <aside className="w-64 shrink-0 border-r border-white/10 flex flex-col">
        <div className="p-5 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2" data-testid="admin-sidebar-logo">
            <div className="h-8 w-8 flex items-center justify-center border border-white/20 bg-white text-black">
              <ShieldAlert className="h-4 w-4" strokeWidth={2} />
            </div>
            <div>
              <div className="font-heading font-black tracking-tighter">Flix VPS</div>
              <div className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest">Admin</div>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, end, tid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={tid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm rounded-sm border ${
                  isActive
                    ? "bg-white text-black border-white"
                    : "border-transparent text-zinc-400 hover:text-white hover:border-white/10 hover:bg-white/5"
                }`
              }
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <div className="text-xs text-zinc-500 font-mono uppercase tracking-widest">Admin</div>
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-xs text-zinc-500 truncate font-mono">{user?.email}</div>
          </div>
          <Button
            variant="outline"
            className="w-full rounded-sm border-white/20 hover:bg-white hover:text-black mb-2"
            onClick={() => navigate("/dashboard")}
            data-testid="go-client-btn"
          >
            Ver como cliente
          </Button>
          <Button
            variant="ghost"
            className="w-full justify-start rounded-sm text-zinc-400 hover:text-white hover:bg-white/5"
            onClick={async () => { await logout(); navigate("/"); }}
            data-testid="admin-logout-btn"
          >
            <LogOut className="h-4 w-4 mr-2" /> Sair
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="max-w-7xl mx-auto p-6 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
